import React from 'react';
import { Button, Typography, Space, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { UploadOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

export default function Home() {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', marginTop: '80px' }}>
      <Card
        style={{
          maxWidth: 680,
          margin: '0 auto',
          padding: '60px 40px',
          background: 'rgba(15, 29, 51, 0.85)',
          border: '1px solid rgba(245, 166, 35, 0.12)',
          borderRadius: 12,
          boxShadow: '0 8px 40px rgba(0,0,0,0.4)',
        }}
      >
        <Title level={1} style={{ color: '#f5a623', fontSize: 42, letterSpacing: '3px', fontWeight: 800, marginBottom: 8 }}>
          CNC 智能报价
        </Title>
        <Title level={3} style={{ color: '#8892a4', fontWeight: 400, marginTop: 0, marginBottom: 32 }}>
          即时 · 精准 · 工业级
        </Title>
        <Paragraph style={{ fontSize: 16, color: '#a0aab4', lineHeight: 1.8, marginBottom: 40 }}>
          上传 3D/2D 图纸，AI 自动解析几何特征
          <br />
          实时计算材料、加工、表面处理、交期
          <br />
          支持多零件批量报价与自动成本校准
        </Paragraph>
        <Button
          type="primary"
          size="large"
          icon={<UploadOutlined />}
          onClick={() => navigate('/upload')}
          style={{
            width: 220,
            height: 52,
            fontSize: 18,
            fontWeight: 600,
            letterSpacing: '2px',
          }}
        >
          开始报价
        </Button>
      </Card>
    </div>
  );
}
